var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeCartPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.775,
    height: 19.356,
    viewBox: "0 0 21.775 19.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-cart-plus",
    "data-name": "Icon awesome-cart-plus",
    d: "M19.08,12.1H8l.247,1.21H18.393a.907.907,0,0,1,.885,1.108l-.209.918a2.118,2.118,0,1,1-2.4.393H8.739A2.117,2.117,0,1,1,6.2,15.4L3.549,2.419H.907A.907.907,0,0,1,0,1.512v-.6A.907.907,0,0,1,.907,0H4.783a.907.907,0,0,1,.889.725l.347,1.694H20.867a.907.907,0,0,1,.885,1.108l-1.787,7.863A.907.907,0,0,1,19.08,12.1ZM15.424,6.351H13.609V4.839a.6.6,0,0,0-.6-.6h-.6a.6.6,0,0,0-.6.6V6.351H9.98a.6.6,0,0,0-.6.6v.6a.6.6,0,0,0,.6.6h1.815V9.678a.6.6,0,0,0,.6.6H13a.6.6,0,0,0,.6-.6V8.166h1.815a.6.6,0,0,0,.6-.6v-.6A.6.6,0,0,0,15.424,6.351Z",
    fill: "#0f70b6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeCartPlus);
export default __webpack_public_path__ + "static/media/Icon-awesome-cart-plus.16d0a9b69cd2644c4d308567a6fb77c0.svg";
export { ForwardRef as ReactComponent };